import GoogleMapsLoader from 'google-maps';
import { isMobile } from '@/scripts/utils';
import isIe from '@/scripts/utils/detect-ie';
import mapStyles from './styles.json';
import './googleMaps.scss';

export default function (el) {
  const {
    key, options, coords, markerImage,
  } = el.dataset;
  GoogleMapsLoader.KEY = key;
  const coordsArr = JSON.parse(coords);
  const [centerElement] = coordsArr;
  GoogleMapsLoader.load((google) => {
    const center = new google.maps.LatLng(centerElement.lat, centerElement.lng);
    const map = new google.maps.Map(el, {
      center,
      styles: mapStyles,
      ...JSON.parse(options),
    });
    if (isMobile()) {
      map.zoom = 11.5;
    }
    const infoWindow = new google.maps.InfoWindow({
      maxWidth: 276,
      maxHeight: 100,
      pixelOffset: 300,
    });
    coordsArr.forEach((coordsElement) => {
      // console.log(coordsArr);
      // console.log(coordsElement);
      const markerCenter = new google.maps.LatLng(coordsElement);
      // console.log(markerCenter);
      const marker = new google.maps.Marker({
        position: markerCenter,
        icon: isIe() ? null : markerImage,
        optimized: false,
        origin: isIe() ? null : new google.maps.Point(16, 16),
        draggable: false,
        animation: google.maps.Animation.DROP,
      });
      function toggleBounceAndInfoWindow() {
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null);
          infoWindow.close(map, marker);
        } else {
          infoWindow.setContent(coordsElement.popupText);
          infoWindow.open(map, marker);
          marker.setAnimation(google.maps.Animation.BOUNCE);
        }
      }
      marker.addListener('click', toggleBounceAndInfoWindow);
      marker.setMap(map);
    });
  });
}



// WEBPACK FOOTER //
// ./components/googleMaps/googleMaps.js